import { GlobalHeaderRight } from '@/components/RightContent';
import { Fetch as GFetch } from '@shoppykey/center-sdk';
import { HooksService } from '@shoppykey/hook';
import { logs } from '@shoppykey/tools';
import { history, RunTimeLayoutConfig } from '@umijs/max';
import _ from 'lodash';
import { themeSettings } from '../config/themeSettings';
import Footer from './components/Footer';
import './global.less';
import type { CurrentUser, GlobalData } from './schema/GlobalData';
import { Fetch } from './utils/fetch';
const ignorePathList = [
  '/auth/login',
  '/auth/sso',
  '/auth/register',
  '/auth/forget',
  '/auth/transfer',
  '/auth/transfer/enterPassword',
];

GFetch.client = Fetch;

async function fetchUserInfo() {
  const info = await Fetch.get<CurrentUser>(`/account/currentUser`);
  return info;
}

export async function getInitialState(): Promise<GlobalData> {
  const hooksService = new HooksService();
  // 如果是登录页面，不执行
  if (!_.includes(ignorePathList, history.location.pathname)) {
    try {
      const currentUser = await fetchUserInfo();
      return {
        currentUser,
        settings: themeSettings,
        hooksService,
      };
    } catch (error) {
      logs.warn(error);
    }
  }
  return {
    settings: themeSettings,
    hooksService,
  };
}

export const layout: RunTimeLayoutConfig = ({ initialState }) => {
  return {
    rightContentRender: () => <GlobalHeaderRight />,
    disableContentMargin: false,
    footerRender: () => <Footer />,
    logo: () => {
      return <img src="/logo.svg" alt="" />;
    },
    token: {
      pageContainer: {
        paddingBlockPageContainerContent: 12,
        paddingInlinePageContainerContent: 24,
      },
      sider: {
        colorMenuBackground: '#fff',
        colorMenuItemDivider: '#dfdfdf',
        colorTextMenu: '#595959',
      },
    },
    ...initialState?.settings,
  };
};
